export default {
  "interviews.detail.pageTitle": "Interview & Blogs",
  "interviews.detail.head.siteName": "LINK-J",

  "interviews.list.head.title": "Interview & Blog | LINK-J",
  "interviews.list.head.description":
    "Discover in-depth interviews with leading professionals in the life sciences industry. ",
  "interviews.list.head.siteName": "LINK-J",
  "interviews.list.title": "Interviews & Blogs",
  "interviews.list.heading.title": "Interviews & Blogs",

  "interviews.categories.special-interviews": "Special Interview",
  "interviews.categories.start-up-interviews": "Start-up Interviews",
  "interviews.categories.supporter": "LINK-J News Letter",
  "interviews.categories.supporter-column": "",
  "interviews.categories.serial-column": "",
  "interviews.categories.column": "What’s in Nihonbashi",
  "interviews.categories.link-j-staff-blog": "LINK-J Staff Blog",
  "interviews.categories.interview": "All Interviews & Blogs",
  "interviews.categories.researcher-interviews": "Researcher Interviews",
} as const;
